 export default function interceptorResponse (response) {
     if (response && response.hasOwnProperty('data')) {
         return response.data;
     }
     return response;
 }
